const EuFlagIcon: React.FC<React.SVGProps<SVGSVGElement>> = (props) => (
    <svg width="14" height="15" viewBox="0 0 14 15" fill="none" xmlns="http://www.w3.org/2000/svg" {...props}>
        <g id="Europe (EU)" clipPath="url(#clip0_1172_314)">
            <path id="Vector" d="M-2.6665 0.108215H16.0002V14.1082H-2.6665V0.108215Z" fill="#003399" />
            <g id="Group">
                <g id="d">
                    <g id="b">
                        <path
                            id="a"
                            d="M7.00331 2.30823L6.7959 2.99959L7.14158 3.06872L7.00331 2.30823Z"
                            fill="#FFCC00"
                        />
                        <path
                            id="Vector_2"
                            d="M7.00304 2.30823L7.21045 2.99959L6.86477 3.06872L7.00304 2.30823Z"
                            fill="#FFCC00"
                        />
                    </g>
                    <g id="c">
                        <g id="b_2">
                            <path
                                id="a_2"
                                d="M7.66028 2.78594L6.93867 2.80233L6.97974 3.15245L7.66028 2.78594Z"
                                fill="#FFCC00"
                            />
                            <path
                                id="Vector_3"
                                d="M7.66052 2.78596L7.06709 3.19686L6.89452 2.88946L7.66052 2.78596Z"
                                fill="#FFCC00"
                            />
                        </g>
                        <g id="b_3">
                            <path
                                id="a_3"
                                d="M7.40935 3.55892L7.17078 2.87769L6.85048 3.02494L7.40935 3.55892Z"
                                fill="#FFCC00"
                            />
                            <path
                                id="Vector_4"
                                d="M7.4095 3.55888L6.83533 3.12147L7.07435 2.86235L7.4095 3.55888Z"
                                fill="#FFCC00"
                            />
                        </g>
                    </g>
                    <g id="c_2">
                        <g id="b_4">
                            <path
                                id="a_4"
                                d="M6.34558 2.78594L7.06719 2.80233L7.02612 3.15245L6.34558 2.78594Z"
                                fill="#FFCC00"
                            />
                            <path
                                id="Vector_5"
                                d="M6.34583 2.78596L6.93926 3.19686L7.11183 2.88946L6.34583 2.78596Z"
                                fill="#FFCC00"
                            />
                        </g>
                        <g id="b_5">
                            <path
                                id="a_5"
                                d="M6.597 3.55892L6.83557 2.87769L7.15587 3.02494L6.597 3.55892Z"
                                fill="#FFCC00"
                            />
                            <path
                                id="Vector_6"
                                d="M6.59685 3.55888L7.17102 3.12147L6.932 2.86235L6.59685 3.55888Z"
                                fill="#FFCC00"
                            />
                        </g>
                    </g>
                </g>
                <g id="d_2">
                    <g id="b_6">
                        <path
                            id="a_6"
                            d="M7.00331 10.6045L6.7959 11.2959L7.14158 11.365L7.00331 10.6045Z"
                            fill="#FFCC00"
                        />
                        <path
                            id="Vector_7"
                            d="M7.00304 10.6045L7.21045 11.2959L6.86477 11.365L7.00304 10.6045Z"
                            fill="#FFCC00"
                        />
                    </g>
                    <g id="c_3">
                        <g id="b_7">
                            <path
                                id="a_7"
                                d="M7.66028 11.0823L6.93867 11.0987L6.97974 11.4488L7.66028 11.0823Z"
                                fill="#FFCC00"
                            />
                            <path
                                id="Vector_8"
                                d="M7.66052 11.0823L7.06709 11.4932L6.89452 11.1858L7.66052 11.0823Z"
                                fill="#FFCC00"
                            />
                        </g>
                        <g id="b_8">
                            <path
                                id="a_8"
                                d="M7.40935 11.8552L7.17078 11.174L6.85048 11.3212L7.40935 11.8552Z"
                                fill="#FFCC00"
                            />
                            <path
                                id="Vector_9"
                                d="M7.4095 11.8552L6.83533 11.4178L7.07435 11.1587L7.4095 11.8552Z"
                                fill="#FFCC00"
                            />
                        </g>
                    </g>
                    <g id="c_4">
                        <g id="b_9">
                            <path
                                id="a_9"
                                d="M6.34558 11.0823L7.06719 11.0987L7.02612 11.4488L6.34558 11.0823Z"
                                fill="#FFCC00"
                            />
                            <path
                                id="Vector_10"
                                d="M6.34583 11.0823L6.93926 11.4932L7.11183 11.1858L6.34583 11.0823Z"
                                fill="#FFCC00"
                            />
                        </g>
                        <g id="b_10">
                            <path
                                id="a_10"
                                d="M6.597 11.8552L6.83557 11.174L7.15587 11.3212L6.597 11.8552Z"
                                fill="#FFCC00"
                            />
                            <path
                                id="Vector_11"
                                d="M6.59685 11.8552L7.17102 11.4178L6.932 11.1587L6.59685 11.8552Z"
                                fill="#FFCC00"
                            />
                        </g>
                    </g>
                </g>
                <g id="e">
                    <g id="d_3">
                        <g id="b_11">
                            <path
                                id="a_11"
                                d="M2.85536 6.45636L2.64795 7.14772L2.99363 7.21685L2.85536 6.45636Z"
                                fill="#FFCC00"
                            />
                            <path
                                id="Vector_12"
                                d="M2.85509 6.45636L3.0625 7.14772L2.71682 7.21685L2.85509 6.45636Z"
                                fill="#FFCC00"
                            />
                        </g>
                        <g id="c_5">
                            <g id="b_12">
                                <path
                                    id="a_12"
                                    d="M3.51233 6.93407L2.79072 6.95046L2.83179 7.30058L3.51233 6.93407Z"
                                    fill="#FFCC00"
                                />
                                <path
                                    id="Vector_13"
                                    d="M3.51257 6.93409L2.91914 7.34499L2.74657 7.03759L3.51257 6.93409Z"
                                    fill="#FFCC00"
                                />
                            </g>
                            <g id="b_13">
                                <path
                                    id="a_13"
                                    d="M3.2614 7.70706L3.02283 7.02582L2.70253 7.17308L3.2614 7.70706Z"
                                    fill="#FFCC00"
                                />
                                <path
                                    id="Vector_14"
                                    d="M3.26106 7.70707L2.68689 7.26966L2.92591 7.01054L3.26106 7.70707Z"
                                    fill="#FFCC00"
                                />
                            </g>
                        </g>
                        <g id="c_6">
                            <g id="b_14">
                                <path
                                    id="a_14"
                                    d="M2.19763 6.93407L2.91924 6.95046L2.87817 7.30058L2.19763 6.93407Z"
                                    fill="#FFCC00"
                                />
                                <path
                                    id="Vector_15"
                                    d="M2.19739 6.93409L2.79082 7.34499L2.96339 7.03759L2.19739 6.93409Z"
                                    fill="#FFCC00"
                                />
                            </g>
                            <g id="b_15">
                                <path
                                    id="a_15"
                                    d="M2.44856 7.70706L2.68713 7.02582L3.00743 7.17308L2.44856 7.70706Z"
                                    fill="#FFCC00"
                                />
                                <path
                                    id="Vector_16"
                                    d="M2.4489 7.70707L3.02307 7.26966L2.78405 7.01054L2.4489 7.70707Z"
                                    fill="#FFCC00"
                                />
                            </g>
                        </g>
                    </g>
                    <g id="d_4">
                        <g id="b_16">
                            <path
                                id="a_16"
                                d="M4.5739 4.14591L5.14807 3.7085L4.90905 3.44938L4.5739 4.14591Z"
                                fill="#FFCC00"
                            />
                            <path
                                id="Vector_17"
                                d="M4.57356 4.14596L4.81213 3.46473L5.13243 3.61198L4.57356 4.14596Z"
                                fill="#FFCC00"
                            />
                        </g>
                        <g id="c_7">
                            <g id="b_17">
                                <path
                                    id="a_17"
                                    d="M4.32239 3.373L4.91582 3.78389L5.08839 3.4765L4.32239 3.373Z"
                                    fill="#FFCC00"
                                />
                                <path
                                    id="Vector_18"
                                    d="M4.32263 3.37304L5.04424 3.38942L5.00317 3.73955L4.32263 3.37304Z"
                                    fill="#FFCC00"
                                />
                            </g>
                            <g id="b_18">
                                <path
                                    id="a_18"
                                    d="M4.98036 2.89526L4.77295 3.58662L5.11863 3.65576L4.98036 2.89526Z"
                                    fill="#FFCC00"
                                />
                                <path
                                    id="Vector_19"
                                    d="M4.98009 2.89526L5.1875 3.58662L4.84182 3.65576L4.98009 2.89526Z"
                                    fill="#FFCC00"
                                />
                            </g>
                        </g>
                        <g id="c_8">
                            <g id="b_19">
                                <path
                                    id="a_19"
                                    d="M5.38655 4.14591L4.81238 3.7085L5.0514 3.44938L5.38655 4.14591Z"
                                    fill="#FFCC00"
                                />
                                <path
                                    id="Vector_20"
                                    d="M5.3864 4.14596L5.14783 3.46473L4.82753 3.61198L5.3864 4.14596Z"
                                    fill="#FFCC00"
                                />
                            </g>
                            <g id="b_20">
                                <path
                                    id="a_20"
                                    d="M5.63757 3.373L5.04414 3.78389L4.87157 3.4765L5.63757 3.373Z"
                                    fill="#FFCC00"
                                />
                                <path
                                    id="Vector_21"
                                    d="M5.63782 3.37304L4.91621 3.38942L4.95728 3.73955L5.63782 3.37304Z"
                                    fill="#FFCC00"
                                />
                            </g>
                        </g>
                    </g>
                    <g id="d_5">
                        <g id="b_21">
                            <path
                                id="a_21"
                                d="M3.84832 5.68386L3.60974 5.00263L3.28945 5.14988L3.84832 5.68386Z"
                                fill="#FFCC00"
                            />
                            <path
                                id="Vector_22"
                                d="M3.84846 5.68388L3.27429 5.24647L3.51332 4.98735L3.84846 5.68388Z"
                                fill="#FFCC00"
                            />
                        </g>
                        <g id="c_9">
                            <g id="b_22">
                                <path
                                    id="a_22"
                                    d="M3.03582 5.68388L3.60998 5.24647L3.37096 4.98735L3.03582 5.68388Z"
                                    fill="#FFCC00"
                                />
                                <path
                                    id="Vector_23"
                                    d="M3.03547 5.68386L3.27405 5.00263L3.59434 5.14988L3.03547 5.68386Z"
                                    fill="#FFCC00"
                                />
                            </g>
                            <g id="b_23">
                                <path
                                    id="a_23"
                                    d="M2.78431 4.9109L3.37774 5.3218L3.55031 5.0144L2.78431 4.9109Z"
                                    fill="#FFCC00"
                                />
                                <path
                                    id="Vector_24"
                                    d="M2.78454 4.91094L3.50615 4.92733L3.46508 5.27745L2.78454 4.91094Z"
                                    fill="#FFCC00"
                                />
                            </g>
                        </g>
                        <g id="c_10">
                            <g id="b_24">
                                <path
                                    id="a_24"
                                    d="M4.09948 4.9109L3.50605 5.3218L3.33348 5.0144L4.09948 4.9109Z"
                                    fill="#FFCC00"
                                />
                                <path
                                    id="Vector_25"
                                    d="M4.09974 4.91088L3.37812 4.92726L3.41919 5.27739L4.09974 4.91088Z"
                                    fill="#FFCC00"
                                />
                            </g>
                            <g id="b_25">
                                <path
                                    id="a_25"
                                    d="M3.44201 4.43323L3.64941 5.12459L3.30374 5.19372L3.44201 4.43323Z"
                                    fill="#FFCC00"
                                />
                                <path
                                    id="Vector_26"
                                    d="M3.44227 4.43323L3.23486 5.12459L3.58054 5.19372L3.44227 4.43323Z"
                                    fill="#FFCC00"
                                />
                            </g>
                        </g>
                    </g>
                    <g id="d_6">
                        <g id="b_26">
                            <path
                                id="a_26"
                                d="M4.10023 9.06896L3.37861 9.08535L3.41968 9.43547L4.10023 9.06896Z"
                                fill="#FFCC00"
                            />
                            <path
                                id="Vector_27"
                                d="M4.10046 9.06898L3.50703 9.47988L3.33446 9.17248L4.10046 9.06898Z"
                                fill="#FFCC00"
                            />
                        </g>
                        <g id="c_11">
                            <g id="b_27">
                                <path
                                    id="a_27"
                                    d="M3.84929 9.84188L3.61072 9.16065L3.29042 9.3079L3.84929 9.84188Z"
                                    fill="#FFCC00"
                                />
                                <path
                                    id="Vector_28"
                                    d="M3.84895 9.8419L3.27478 9.40449L3.51381 9.14537L3.84895 9.8419Z"
                                    fill="#FFCC00"
                                />
                            </g>
                            <g id="b_28">
                                <path
                                    id="a_28"
                                    d="M3.03631 9.8419L3.61047 9.40449L3.37145 9.14537L3.03631 9.8419Z"
                                    fill="#FFCC00"
                                />
                                <path
                                    id="Vector_29"
                                    d="M3.03645 9.84188L3.27502 9.16065L3.59532 9.3079L3.03645 9.84188Z"
                                    fill="#FFCC00"
                                />
                            </g>
                        </g>
                        <g id="c_12">
                            <g id="b_29">
                                <path
                                    id="a_29"
                                    d="M3.44249 8.59125L3.6499 9.28261L3.30422 9.35174L3.44249 8.59125Z"
                                    fill="#FFCC00"
                                />
                                <path
                                    id="Vector_30"
                                    d="M3.44276 8.59125L3.23535 9.28261L3.58103 9.35174L3.44276 8.59125Z"
                                    fill="#FFCC00"
                                />
                            </g>
                            <g id="b_30">
                                <path
                                    id="a_30"
                                    d="M2.78503 9.06896L3.50664 9.08535L3.46557 9.43547L2.78503 9.06896Z"
                                    fill="#FFCC00"
                                />
                                <path
                                    id="Vector_31"
                                    d="M2.78528 9.06898L3.37871 9.47988L3.55128 9.17248L2.78528 9.06898Z"
                                    fill="#FFCC00"
                                />
                            </g>
                        </g>
                    </g>
                    <g id="d_7">
                        <g id="b_31">
                            <path
                                id="a_31"
                                d="M5.60071 10.4606L4.8791 10.4769L4.92017 10.8271L5.60071 10.4606Z"
                                fill="#FFCC00"
                            />
                            <path
                                id="Vector_32"
                                d="M5.60095 10.4605L5.00752 10.8714L4.83495 10.564L5.60095 10.4605Z"
                                fill="#FFCC00"
                            />
                        </g>
                        <g id="c_13">
                            <g id="b_32">
                                <path
                                    id="a_32"
                                    d="M5.34978 11.2335L5.11121 10.5523L4.79091 10.6995L5.34978 11.2335Z"
                                    fill="#FFCC00"
                                />
                                <path
                                    id="Vector_33"
                                    d="M5.34993 11.2335L4.77576 10.7961L5.01478 10.537L5.34993 11.2335Z"
                                    fill="#FFCC00"
                                />
                            </g>
                            <g id="b_33">
                                <path
                                    id="a_33"
                                    d="M4.53679 11.2335L5.11096 10.7961L4.87194 10.537L4.53679 11.2335Z"
                                    fill="#FFCC00"
                                />
                                <path
                                    id="Vector_34"
                                    d="M4.53694 11.2335L4.77551 10.5523L5.09581 10.6995L4.53694 11.2335Z"
                                    fill="#FFCC00"
                                />
                            </g>
                        </g>
                        <g id="c_14">
                            <g id="b_34">
                                <path
                                    id="a_34"
                                    d="M4.94347 9.98279L5.15088 10.6741L4.8052 10.7433L4.94347 9.98279Z"
                                    fill="#FFCC00"
                                />
                                <path
                                    id="Vector_35"
                                    d="M4.94325 9.98279L4.73584 10.6741L5.08152 10.7433L4.94325 9.98279Z"
                                    fill="#FFCC00"
                                />
                            </g>
                            <g id="b_35">
                                <path
                                    id="a_35"
                                    d="M4.28601 10.4606L5.00762 10.4769L4.96655 10.8271L4.28601 10.4606Z"
                                    fill="#FFCC00"
                                />
                                <path
                                    id="Vector_36"
                                    d="M4.28577 10.4606L4.8792 10.8715L5.05177 10.5641L4.28577 10.4606Z"
                                    fill="#FFCC00"
                                />
                            </g>
                        </g>
                    </g>
                </g>
                <g id="e_2">
                    <g id="d_8">
                        <g id="b_36">
                            <path
                                id="a_36"
                                d="M11.1515 6.45636L11.3589 7.14772L11.0132 7.21685L11.1515 6.45636Z"
                                fill="#FFCC00"
                            />
                            <path
                                id="Vector_37"
                                d="M11.1513 6.45636L10.9438 7.14772L11.2895 7.21685L11.1513 6.45636Z"
                                fill="#FFCC00"
                            />
                        </g>
                        <g id="c_15">
                            <g id="b_37">
                                <path
                                    id="a_37"
                                    d="M10.494 6.93407L11.2156 6.95046L11.1746 7.30058L10.494 6.93407Z"
                                    fill="#FFCC00"
                                />
                                <path
                                    id="Vector_38"
                                    d="M10.4943 6.93409L11.0877 7.34499L11.2603 7.03759L10.4943 6.93409Z"
                                    fill="#FFCC00"
                                />
                            </g>
                            <g id="b_38">
                                <path
                                    id="a_38"
                                    d="M10.7454 7.70706L10.984 7.02582L11.3043 7.17308L10.7454 7.70706Z"
                                    fill="#FFCC00"
                                />
                                <path
                                    id="Vector_39"
                                    d="M10.7453 7.70707L11.3195 7.26966L11.0804 7.01054L10.7453 7.70707Z"
                                    fill="#FFCC00"
                                />
                            </g>
                        </g>
                        <g id="c_16">
                            <g id="b_39">
                                <path
                                    id="a_39"
                                    d="M11.8087 6.93407L11.0871 6.95046L11.1282 7.30058L11.8087 6.93407Z"
                                    fill="#FFCC00"
                                />
                                <path
                                    id="Vector_40"
                                    d="M11.809 6.93409L11.2155 7.34499L11.043 7.03759L11.809 6.93409Z"
                                    fill="#FFCC00"
                                />
                            </g>
                            <g id="b_40">
                                <path
                                    id="a_40"
                                    d="M11.5578 7.70706L11.3192 7.02582L10.9989 7.17308L11.5578 7.70706Z"
                                    fill="#FFCC00"
                                />
                                <path
                                    id="Vector_41"
                                    d="M11.5579 7.70707L10.9838 7.26966L11.2228 7.01054L11.5579 7.70707Z"
                                    fill="#FFCC00"
                                />
                            </g>
                        </g>
                    </g>
                    <g id="d_9">
                        <g id="b_41">
                            <path
                                id="a_41"
                                d="M9.43293 4.14591L8.85877 3.7085L9.09779 3.44938L9.43293 4.14591Z"
                                fill="#FFCC00"
                            />
                            <path
                                id="Vector_42"
                                d="M9.43279 4.14596L9.19422 3.46473L8.87392 3.61198L9.43279 4.14596Z"
                                fill="#FFCC00"
                            />
                        </g>
                        <g id="c_17">
                            <g id="b_42">
                                <path
                                    id="a_42"
                                    d="M9.68395 3.373L9.09053 3.78389L8.91795 3.4765L9.68395 3.373Z"
                                    fill="#FFCC00"
                                />
                                <path
                                    id="Vector_43"
                                    d="M9.68372 3.37298L8.96211 3.38936L9.00318 3.73949L9.68372 3.37298Z"
                                    fill="#FFCC00"
                                />
                            </g>
                            <g id="b_43">
                                <path
                                    id="a_43"
                                    d="M9.02648 2.89526L9.23389 3.58662L8.88821 3.65576L9.02648 2.89526Z"
                                    fill="#FFCC00"
                                />
                                <path
                                    id="Vector_44"
                                    d="M9.02626 2.89526L8.81885 3.58662L9.16453 3.65576L9.02626 2.89526Z"
                                    fill="#FFCC00"
                                />
                            </g>
                        </g>
                        <g id="c_18">
                            <g id="b_44">
                                <path
                                    id="a_44"
                                    d="M8.6198 4.14591L9.19397 3.7085L8.95494 3.44938L8.6198 4.14591Z"
                                    fill="#FFCC00"
                                />
                                <path
                                    id="Vector_45"
                                    d="M8.61994 4.14596L8.85852 3.46473L9.17882 3.61198L8.61994 4.14596Z"
                                    fill="#FFCC00"
                                />
                            </g>
                            <g id="b_45">
                                <path
                                    id="a_45"
                                    d="M8.36878 3.373L8.96221 3.78389L9.13478 3.4765L8.36878 3.373Z"
                                    fill="#FFCC00"
                                />
                                <path
                                    id="Vector_46"
                                    d="M8.36901 3.37298L9.09063 3.38936L9.04956 3.73949L8.36901 3.37298Z"
                                    fill="#FFCC00"
                                />
                            </g>
                        </g>
                    </g>
                    <g id="d_10">
                        <g id="b_46">
                            <path
                                id="a_46"
                                d="M10.158 5.68386L10.3966 5.00263L10.7169 5.14988L10.158 5.68386Z"
                                fill="#FFCC00"
                            />
                            <path
                                id="Vector_47"
                                d="M10.1579 5.68388L10.7321 5.24647L10.493 4.98735L10.1579 5.68388Z"
                                fill="#FFCC00"
                            />
                        </g>
                        <g id="c_19">
                            <g id="b_47">
                                <path
                                    id="a_47"
                                    d="M10.971 5.68388L10.3969 5.24647L10.6359 4.98735L10.971 5.68388Z"
                                    fill="#FFCC00"
                                />
                                <path
                                    id="Vector_48"
                                    d="M10.9709 5.68386L10.7323 5.00263L10.412 5.14988L10.9709 5.68386Z"
                                    fill="#FFCC00"
                                />
                            </g>
                            <g id="b_48">
                                <path
                                    id="a_48"
                                    d="M11.222 4.9109L10.6286 5.3218L10.456 5.0144L11.222 4.9109Z"
                                    fill="#FFCC00"
                                />
                                <path
                                    id="Vector_49"
                                    d="M11.2218 4.91094L10.5002 4.92733L10.5413 5.27745L11.2218 4.91094Z"
                                    fill="#FFCC00"
                                />
                            </g>
                        </g>
                        <g id="c_20">
                            <g id="b_49">
                                <path
                                    id="a_49"
                                    d="M9.90687 4.9109L10.5003 5.3218L10.6729 5.0144L9.90687 4.9109Z"
                                    fill="#FFCC00"
                                />
                                <path
                                    id="Vector_50"
                                    d="M9.9071 4.91088L10.6287 4.92726L10.5876 5.27739L9.9071 4.91088Z"
                                    fill="#FFCC00"
                                />
                            </g>
                            <g id="b_50">
                                <path
                                    id="a_50"
                                    d="M10.5643 4.43323L10.3569 5.12459L10.7026 5.19372L10.5643 4.43323Z"
                                    fill="#FFCC00"
                                />
                                <path
                                    id="Vector_51"
                                    d="M10.5646 4.43323L10.772 5.12459L10.4263 5.19372L10.5646 4.43323Z"
                                    fill="#FFCC00"
                                />
                            </g>
                        </g>
                    </g>
                    <g id="d_11">
                        <g id="b_51">
                            <path
                                id="a_51"
                                d="M9.90612 9.06896L10.6277 9.08535L10.5867 9.43547L9.90612 9.06896Z"
                                fill="#FFCC00"
                            />
                            <path
                                id="Vector_52"
                                d="M9.90638 9.06898L10.4998 9.47988L10.6724 9.17248L9.90638 9.06898Z"
                                fill="#FFCC00"
                            />
                        </g>
                        <g id="c_21">
                            <g id="b_52">
                                <path
                                    id="a_52"
                                    d="M10.1575 9.84194L10.3961 9.16071L10.7164 9.30796L10.1575 9.84194Z"
                                    fill="#FFCC00"
                                />
                                <path
                                    id="Vector_53"
                                    d="M10.1574 9.84196L10.7316 9.40455L10.4925 9.14543L10.1574 9.84196Z"
                                    fill="#FFCC00"
                                />
                            </g>
                            <g id="b_53">
                                <path
                                    id="a_53"
                                    d="M10.97 9.84196L10.3959 9.40455L10.6349 9.14543L10.97 9.84196Z"
                                    fill="#FFCC00"
                                />
                                <path
                                    id="Vector_54"
                                    d="M10.9704 9.84194L10.7318 9.16071L10.4115 9.30796L10.9704 9.84194Z"
                                    fill="#FFCC00"
                                />
                            </g>
                        </g>
                        <g id="c_22">
                            <g id="b_54">
                                <path
                                    id="a_54"
                                    d="M10.5639 8.59125L10.3564 9.28261L10.7021 9.35174L10.5639 8.59125Z"
                                    fill="#FFCC00"
                                />
                                <path
                                    id="Vector_55"
                                    d="M10.5636 8.59125L10.771 9.28261L10.4253 9.35174L10.5636 8.59125Z"
                                    fill="#FFCC00"
                                />
                            </g>
                            <g id="b_55">
                                <path
                                    id="a_55"
                                    d="M11.2213 9.06896L10.4997 9.08535L10.5408 9.43547L11.2213 9.06896Z"
                                    fill="#FFCC00"
                                />
                                <path
                                    id="Vector_56"
                                    d="M11.2216 9.06898L10.6281 9.47988L10.4556 9.17248L11.2216 9.06898Z"
                                    fill="#FFCC00"
                                />
                            </g>
                        </g>
                    </g>
                    <g id="d_12">
                        <g id="b_56">
                            <path
                                id="a_56"
                                d="M8.40563 10.4606L9.12725 10.4769L9.08618 10.8271L8.40563 10.4606Z"
                                fill="#FFCC00"
                            />
                            <path
                                id="Vector_57"
                                d="M8.4054 10.4605L8.99883 10.8714L9.1714 10.564L8.4054 10.4605Z"
                                fill="#FFCC00"
                            />
                        </g>
                        <g id="c_23">
                            <g id="b_57">
                                <path
                                    id="a_57"
                                    d="M8.65657 11.2335L8.89514 10.5523L9.21544 10.6995L8.65657 11.2335Z"
                                    fill="#FFCC00"
                                />
                                <path
                                    id="Vector_58"
                                    d="M8.65691 11.2335L9.23108 10.7961L8.99205 10.537L8.65691 11.2335Z"
                                    fill="#FFCC00"
                                />
                            </g>
                            <g id="b_58">
                                <path
                                    id="a_58"
                                    d="M9.46955 11.2335L8.89539 10.7961L9.13441 10.537L9.46955 11.2335Z"
                                    fill="#FFCC00"
                                />
                                <path
                                    id="Vector_59"
                                    d="M9.46941 11.2335L9.23084 10.5523L8.91054 10.6995L9.46941 11.2335Z"
                                    fill="#FFCC00"
                                />
                            </g>
                        </g>
                        <g id="c_24">
                            <g id="b_59">
                                <path
                                    id="a_59"
                                    d="M9.06336 9.98279L8.85596 10.6741L9.20164 10.7433L9.06336 9.98279Z"
                                    fill="#FFCC00"
                                />
                                <path
                                    id="Vector_60"
                                    d="M9.0631 9.98279L9.27051 10.6741L8.92483 10.7433L9.0631 9.98279Z"
                                    fill="#FFCC00"
                                />
                            </g>
                            <g id="b_60">
                                <path
                                    id="a_60"
                                    d="M9.72083 10.4606L8.99922 10.4769L9.04029 10.8271L9.72083 10.4606Z"
                                    fill="#FFCC00"
                                />
                                <path
                                    id="Vector_61"
                                    d="M9.72058 10.4606L9.12715 10.8715L8.95457 10.5641L9.72058 10.4606Z"
                                    fill="#FFCC00"
                                />
                            </g>
                        </g>
                    </g>
                </g>
            </g>
        </g>
        <defs>
            <clipPath id="clip0_1172_314">
                <rect y="0.108215" width="14" height="14" fill="white" rx="5.25" />
            </clipPath>
        </defs>
    </svg>
);
export default EuFlagIcon;
